<div class="app-container">
  <div class="brand-header-container">
  <csi-ng-brand-header 
    [showUser]=true 
    [user]="user" 
    [site]="siteName" 
    [bttnType]="bttnType"
    (messageToApp)="receiveFromHeader($event)">
  </csi-ng-brand-header>
  </div>
  <main class="main-content">
    <div class="content-container">
        <!-- MAIN NAVIGATION -->
        @if (isValidUser) {
          <nav aria-label="Main Navigation">
            <h2 class="visually-hidden">Main Navigation</h2>
            <mat-tab-group 
              class="margin-lg-bottom" 
              [selectedIndex]="selectedTab" 
              (selectedTabChange)="onTabChange($event)"
            >
              @for (tab of tabRoutes | isTabAvailable: changeIndex; track tab) {
                <mat-tab [label]="tab.label" [aria-label]="tab.class">
                  @if (tab.icon) {
                    <ng-template mat-tab-label>
                      <span class="tab-with-icon"><mat-icon>{{tab.icon}}</mat-icon>{{tab.label}}</span>
                    </ng-template>
                  }
                </mat-tab>
              }
            </mat-tab-group>  
            <div class="nav-actions">
              <button mat-icon-button (click)="toggleDarkMode()" class="theme-toggle" title="Toggle light and dark themes. Additional options available in the settings.">
                <mat-icon>{{ isDarkMode ? 'dark_mode' : 'light_mode' }}</mat-icon>
              </button>
              <a
                mat-icon-button
                href="https://its.uiowa.edu/services/time-keeping-system#support-training"
                title="Time Keeping System support and training"
                aria-label="Time Keeping System support and training"
              >
                <mat-icon>help_outline</mat-icon>
              </a>
            </div>
          </nav>
        } 
        <!-- TEST MESSAGE -->
        @if (isTestEnvironment && ! isTestWarningHidden) {
        <div class="warning-msg">
          <div>

            <img src="assets/images/warning.png" width="64" style="float: left;">
          </div>
          <div>
            <div>
              This is the TKS test environment. Data created here will not be available in the
              production environment so please be sure you're creating your real timesheets and approvals there not here.
            </div>
            <p>
              <a href="https://time.iowa.uiowa.edu" title="Go to the production TKS environment">Click here to visit the
                production Time Keeping System (TKS).</a>
            </p>
            <div class="flex flex-end">
              <button mat-flat-button (click)="toggleMinimizeTestWarning()">Hide</button>
            </div>
          </div>
        </div>
        } 
        @else if (isTestEnvironment && isTestWarningHidden) {
        <div class="test-env-warning-minimized" (click)="toggleMinimizeTestWarning()">
          <img src="assets/images/warning.png" width="64" style="float: left;">
          Test
        </div>
        }
          
        <!-- IMPERSONATION MESSAGE -->
        <div>
          <div class="impersonation-warning page-section-container warning-msg" [class]="{ removed: ! isImpersonating}">
            <mat-icon>security</mat-icon>&nbsp;&nbsp;You are impersonating '{{tksUser?.displayName}} ({{tksUser?.hawkId}})'.
            <!-- <button mat-icon-button (click)="endImpersonation()" title="End impersonation session"><mat-icon>logout</mat-icon></button> -->
            &nbsp;<a [routerLink]="['/settings']">Manage in settings.</a>
          </div>
        </div>
    </div>
    <router-outlet></router-outlet>
  </main>
  <csi-ng-brand-footer [siteFooter]="siteFooter" [showFooter]=true [showAddress1]=true [showAddress2]=false
    [showCity]=true [showState]=true [showZip]=true [showPhone]=true [showEmail]=true [showFacebook]=true [showX]=true
    [showInstagram]=false (messageToApp)="receiveFromFooter($event)">
  </csi-ng-brand-footer>
</div>
